import ReportDetails from "../../pages/dashboard/report/ReportDetails";
import ReportIndex from "../../pages/dashboard/report/ReportIndex";
import { ALL_ROUTES } from "../AllRoutes";

export const report_routes_group = [
  {
    path: ALL_ROUTES?.DASHBOARD_REPORT,
    element: ReportIndex,
  },
  {
    path: ALL_ROUTES?.DASHBOARD_REPORT_HISTORY,
    element: ReportDetails,
  },
];
